export default "__VITE_ASSET__D34MHEYY__"